import React, {Children} from 'react';

import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, {WithStyles} from '@material-ui/core/styles/withStyles';
import classNames from 'classnames';

const styles = () => {
  return createStyles({
    root: {
      display: 'flex',
      position: 'sticky',
      left: 0,
      backgroundColor: 'inherit',
    },
  });
};

type Props = React.HTMLAttributes<HTMLDivElement> & WithStyles<typeof styles>;

const Component: React.FC<Props> = ({classes, className, children, ...props}) => {
  return (
    !!Children.count(children) && (
      <div {...props} className={classNames(className, classes.root)}>
        {children}
      </div>
    )
  );
};

const PinnedColumns = withStyles(styles)(Component);

export default PinnedColumns;
